import { useMemo } from 'react';
import { Typography } from 'seagull';
import { ApprovalMethodNoticePeriodField } from "../../../../components/agreement-controllers/ApprovalMethodNoticePeriodField/ApprovalMethodNoticePeriodField";
import { useStore } from "../../../../contexts";
import { approvalMethodNoticePeriodModel } from "../../../../models";
import pluralize from "../../../../utils/pluralize";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { jsx as _jsx } from "react/jsx-runtime";
const AutoApproveAmendmentsModalContent = _ref => {
  let {
    draft,
    setDraft
  } = _ref;
  const userInfo = useStore(state => state.userInfo);
  const worksAt = userInfo === null || userInfo === void 0 ? void 0 : userInfo.business();
  const amendmentsAutoApproval = useMemo(() => {
    var _worksAt$settings;
    const amendmentsApprovalMethod = draft.amendmentsApprovalMethod();
    if (amendmentsApprovalMethod) return approvalMethodNoticePeriodModel.isAutoApproval(amendmentsApprovalMethod);
    if (worksAt !== null && worksAt !== void 0 && (_worksAt$settings = worksAt.settings) !== null && _worksAt$settings !== void 0 && _worksAt$settings.amendmentsApprovalMethod) return approvalMethodNoticePeriodModel.isAutoApproval(worksAt.settings.amendmentsApprovalMethod);
    return false;
  }, [draft, worksAt]);
  const defaultAutoApprovalMethod = draft.defaultAutoApprovalMethod(worksAt);
  const amendmentsAutoApprovalNoticePeriod = useMemo(() => {
    var _worksAt$settings2;
    const amendmentsApprovalMethod = draft.amendmentsApprovalMethod();
    if (amendmentsApprovalMethod && approvalMethodNoticePeriodModel.isAutoApproval(amendmentsApprovalMethod)) return amendmentsApprovalMethod.auto.noticePeriodDays;
    if (worksAt !== null && worksAt !== void 0 && (_worksAt$settings2 = worksAt.settings) !== null && _worksAt$settings2 !== void 0 && _worksAt$settings2.amendmentsApprovalMethod && approvalMethodNoticePeriodModel.isAutoApproval(worksAt.settings.amendmentsApprovalMethod)) return worksAt.settings.amendmentsApprovalMethod.auto.noticePeriodDays;
    return 30;
  }, [draft, worksAt]);
  const getApprovalMethodNoticePeriod = noticePeriodDays => ({
    type: 'auto',
    auto: {
      noticePeriodDays
    }
  });
  const manualApprovalMethod = {
    type: 'manual'
  };
  return /*#__PURE__*/_jsx(ApprovalMethodNoticePeriodField, {
    info: "Amendments will take effect automatically if the client doesn't disable within the notice period set. Amended invoices issued during the notice period will require client approval.",
    text: "Automatically approve amendments after a defined period",
    testid: "amendments-auto-approval",
    enabled: amendmentsAutoApproval,
    onToggle: () => {
      amendmentsAutoApproval ? setDraft(draft.setAmendmentsApprovalMethod(manualApprovalMethod)) : setDraft(draft.setAmendmentsApprovalMethod(getApprovalMethodNoticePeriod(defaultAutoApprovalMethod)));
    },
    noticePeriod: amendmentsAutoApprovalNoticePeriod,
    onChangePeriod: noticePeriod => {
      setDraft(draft.setAmendmentsApprovalMethod(getApprovalMethodNoticePeriod(Number(noticePeriod))));
    }
  });
};
export default function AutoApproveAmendmentsCell(_ref2) {
  let {
    draft,
    index,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref2;
  const amendmentsApprovalMethod = draft.amendmentsApprovalMethod();
  const onClick = () => onOpenModal({
    renderContent: _ref3 => {
      let {
        draft,
        setDraft
      } = _ref3;
      return {
        title: 'Auto approve amendments',
        testid: "edit-auto-approve-amendments-modal",
        onSubmit: defaultBehavior => {
          defaultBehavior();
        },
        content: /*#__PURE__*/_jsx(AutoApproveAmendmentsModalContent, {
          draft: draft,
          setDraft: setDraft
        })
      };
    }
  });
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-auto-approve-amendments-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "auto-approve-amendments-".concat(index),
      children: amendmentsApprovalMethod && approvalMethodNoticePeriodModel.isAutoApproval(amendmentsApprovalMethod) ? "".concat(pluralize('day', amendmentsApprovalMethod.auto.noticePeriodDays, true), " notice") : 'Disabled'
    })
  });
}